import axios from 'axios';

import { UserV3 } from '@wegoTypes/userV3';

interface UpdateUserV3Data {
  profile: {
    firstName: string;
    lastName: string;
    nationality?: string;
    phoneNumber?: string;
    phoneCountryCode?: string;
  };
  primaryTraveller: {
    firstName: string;
    lastName: string;
    nationality?: string;
    gender?: 'MALE' | 'FEMALE';
    dateOfBirth?: string;
    travellerType: 'ADULT';
    travellerDocuments?: Array<{
      documentNumber: string;
      documentType: 'PASSPORT' | 'NATIONAL_ID';
      expiryDate?: string;
      issuingCountry?: string;
    }>;
  };
}

export const updateUserV3 = async (apiBaseUrl: string, data: UpdateUserV3Data): Promise<UserV3> => {
  const response = await axios.put<{ data: UserV3 }>(
    `${apiBaseUrl}/user-centric/authenticated/v3/users/details`,
    data,
    {
      withCredentials: true,
    },
  );

  if (response.status === 200) {
    return response.data.data;
  }
  throw new Error(response.statusText);
};
